import {
  CompaniesParams,
  CompaniesParamsSchema,
  CompaniesSchema,
  UpdateCurrentCompanyParams,
  UpdateCurrentCompanyParamsSchema,
} from '@/api/_schemas/companies'
import { AuthenticateSchema } from '@/api/_schemas/users'
import { apiBf as api } from '@/config/api-bf'
import { schematize } from '@/services/schematize'

async function getCompanies(params: CompaniesParams, signal?: AbortSignal) {
  const { page, search } = schematize(params, CompaniesParamsSchema)

  const { data } = await api.get('api/auth/empresa-list', {
    params: { page, search, per_page: 20 },
    signal,
  })

  return schematize(data, CompaniesSchema)
}

async function updateCurrentCompany(params: UpdateCurrentCompanyParams) {
  const { id } = schematize(params, UpdateCurrentCompanyParamsSchema)

  const { data } = await api.post(`api/auth/empresa-update/${id}`)

  return schematize(data, AuthenticateSchema)
}

export { getCompanies, updateCurrentCompany }
